import React, { useMemo, useState } from 'react'
import { Loader } from '@refera/ui-web'
import { Grid, InputLabel, FormControl, Select, MenuItem } from '@material-ui/core'

import * as Modal from '_components/modal/generic-modal'
import { REGIONS_FIELDS } from '_utils/regions'

import useStyles from './styles'

const menuProps = {
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'center',
  },
}

const ServiceAreasModal = ({
  modalOpen,
  handleModal,
  handleSubmit,
  cityOptions,
  stateOptions,
  stateNames,
  disabledSubmit,
  regionsList,
  isLoading,
}) => {
  const styles = useStyles()

  const [selectedCity, setSelectedCity] = useState('')
  const [selectedState, setSelectedState] = useState('')
  const [isCityDisabled, setIsCityDisabled] = useState(true)
  const [availableCities, setAvailableCities] = useState([])

  const selectedCitiesSet = useMemo(() => {
    return new Set(regionsList?.map(r => r.city))
  }, [regionsList])

  const onSelectState = e => {
    setIsCityDisabled(false)
    setSelectedState(e)
    handleGetStateCities(e)
  }

  const handleGetStateCities = stateName => {
    const currentState = stateOptions.find(state => state.name === stateName)

    if (!currentState) {
      setAvailableCities([])
      return
    }
    const cities = cityOptions.filter(city => city.state.id === currentState?.id)
    setAvailableCities(cities)
  }

  const handleSubmitRegion = () => {
    const data = {
      state: selectedState,
      city: selectedCity,
    }
    handleSubmit(data)
    handleModal()
  }

  return (
    <>
      <Loader hasBackdrop open={isLoading} />
      <Modal.Root open={modalOpen} onClose={handleModal} className={styles.root}>
        <Modal.TitleModal title={REGIONS_FIELDS.TITLE} />

        <Modal.Content>
          <Grid container className={styles.wrapper}>
            <FormControl fullWidth>
              <InputLabel id="select-states">Estado</InputLabel>
              <Select
                MenuProps={menuProps}
                labelId="select-states"
                label="Estado"
                value={selectedState}
                onChange={e => onSelectState(e.target.value)}
                className={styles.contentState}
              >
                {stateNames.map(state => (
                  <MenuItem value={state} key={state}>
                    {state}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="select-cities">Cidade</InputLabel>
              <Select
                disabled={isCityDisabled}
                MenuProps={menuProps}
                labelId="select-cities"
                label="Cidade"
                value={selectedCity}
                onChange={e => setSelectedCity(e.target.value)}
                className={styles.contentCity}
              >
                {availableCities
                  ?.toSorted((a, b) => a.label.localeCompare(b.label))
                  .map(city => (
                    <MenuItem
                      value={city.label}
                      key={city.id || city.label}
                      disabled={selectedCitiesSet.has(city.label)}
                    >
                      {city.label}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
        </Modal.Content>

        <Modal.Actions>
          <Modal.ButtonRed onClick={handleModal}>Cancelar</Modal.ButtonRed>
          <Modal.ButtonFullBlue
            onClick={handleSubmitRegion}
            disabled={disabledSubmit || !selectedState || !selectedCity}
          >
            Salvar
          </Modal.ButtonFullBlue>
        </Modal.Actions>
      </Modal.Root>
    </>
  )
}

export default ServiceAreasModal
